import {LOGOUT} from '../../constants/LoginConstants';
import {ActionWithoutPayload} from '../../@types/actions';

export const LogoutAction = (): ActionWithoutPayload<any> => ({type: LOGOUT});
